import axios from "axios";
import Cookies from "js-cookie";
import { globalStorage } from "../helpers";

// Global request interceptor: attach SSO Bearer token to all outgoing requests
axios.interceptors.request.use(
  (config) => {
    const token = Cookies.get("fin_access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Global response interceptor: handle 401 (token expired) by redirecting to login
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth data and redirect to login
      Cookies.remove("fin_access_token");
      Cookies.remove("fin_refresh_token");
      Cookies.remove("fin_unit_data");
      Cookies.remove("fin_unit_name");
      globalStorage.removeItem("fin_user_data");
      globalStorage.removeItem("fin_menu_data");
      globalStorage.removeItem("fin_units");

      // Only redirect if not already on login page
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
